import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';

import {CodelistDetail} from '../../components/CodelistDetail/CodelistDetail';

export function SalesCodelistDetail() {
  return (
    <CodelistDetail
      breadcrumbs={[
        {
          label: i18n.t('page.codelists.pageTitle'),
          href: settingsRoutes.codelists,
        },
      ]}
    />
  );
}
